import { render, staticRenderFns } from "./goods-pool.vue?vue&type=template&id=2420c0e4&scoped=true"
import script from "./goods-pool.vue?vue&type=script&lang=js"
export * from "./goods-pool.vue?vue&type=script&lang=js"
import style0 from "./goods-pool.vue?vue&type=style&index=0&id=2420c0e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2420c0e4",
  null
  
)

export default component.exports